import { render, staticRenderFns } from "./SubHeaderList.vue?vue&type=template&id=6d1ac89e&"
import script from "./SubHeaderList.vue?vue&type=script&lang=js&"
export * from "./SubHeaderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports